import { SET_TAB } from './types';

export const setTabActiveById = (id) => {
    return {
        type: SET_TAB,
        payload: id
    };
}